import { ChevronDown, Luggage, Users } from "lucide-react";
import { Counter } from "@/components/booking/BookingFields";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLang } from "@/lib/i18n";

export default function PassengerSelector({ passengers, luggage, onPassengers, onLuggage }) {
  const { t } = useLang();

  const party = `${passengers} ${passengers > 1 ? t("bk.pax_many") : t("bk.pax_one")} · ${luggage} ${luggage > 1 ? t("bk.bag_many") : t("bk.bag_one")}`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="booking-passenger-summary"
          className="flex h-14 w-full items-center justify-between rounded-2xl border border-ink/10 bg-white px-4 text-left transition-[border-color,box-shadow] hover:border-miles/35 focus:border-miles focus:outline-none focus:ring-4 focus:ring-miles/10">
          <span className="flex items-center gap-3 text-[15px] font-medium text-ink">
            <Users className="h-4 w-4 text-miles" strokeWidth={1.5} />
            {party}
          </span>
          <ChevronDown className="h-4 w-4 text-slate" strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[22rem] rounded-3xl border-ink/10 bg-white p-3 shadow-[0_24px_70px_rgba(16,24,40,0.14)]">
        <div className="space-y-3">
          <Counter label={t("bk.pax")} value={passengers} min={1} max={7} onChange={onPassengers} testId="booking-passengers" />
          <Counter label={t("bk.bags")} value={luggage} min={0} max={10} onChange={onLuggage} testId="booking-luggage" />
        </div>
      </PopoverContent>
    </Popover>
  );
}
